import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { useDialog } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { DeliveryMethodDialog } from "./DeliveryMethodDialog";
import { DeliveryMethodDto } from "./types";


export function DeliveryMethodListPage() {
    const [useDeliveryMethodsStore] = useState(() => createListStore<DeliveryMethodDto>({
        path: "settings/deliveryMethods",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "code", label: "Code", width: 120 },
            { column: "description", label: "Description", width: 300 },            
            { column: "isActive", label: "Active", width: 120, type: "bool" },
            { column: "isDefault", label: "Default", width: 120, type: "bool" },            
            { column: "lastRefresh", label: "Last refresh", width: 120, type: "datetime" },
            { column: "generatePostNr", label: "Generate postal number", width: 100, type: "bool" },
        ],
    }));

    const deliveryMethods = useDeliveryMethodsStore(p => ({ selectedItem: p.selectedItem }));
    const editDialog = useDialog(close => <DeliveryMethodDialog close={close}
        deliveryMethod={deliveryMethods.selectedItem!} useDeliveryMethodsStore={useDeliveryMethodsStore}
        onChange={() => { useDeliveryMethodsStore.getState().fetch(); }} />);
    return <>
        {editDialog.render()}
        <PageTitle title="Delivery methods" />
        {renderListStore(useDeliveryMethodsStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={deliveryMethods.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
            ]),
        })}
    </>;
}
